import { EventEmitter } from 'events';
import assign from 'object-assign';
import { findIndex, find } from 'lodash';
import i18next from 'i18next';
import ToastStore from 'stores/ToastStore';
import AdminAppDispatcher from '../dispatcher/AdminAppDispatcher';
import AdminConstants from '../constants/AdminConstants';
const ActionTypes = AdminConstants.ActionTypes;
let contracts = [];
let contract = {};
function toast(message, level) {
    if (!level)
        level = 'error';
    ToastStore.getNotifications().push({
        title: message,
        body: '',
        level: level,
    });
    ToastStore.emitChange();
}
const ContractsStore = assign({}, EventEmitter.prototype, {
    defaults: {
        status: false,
        error: false,
    },
    reset() {
        this.status = false;
        this.error = false;
    },
    getStatus() {
        return this.status;
    },
    getError() {
        return this.error;
    },
    getContractIndex(contract) {
        return findIndex(contracts, {
            _id: contract._id,
        });
    },
    getContracts() {
        return contracts || [];
    },
    getContract() {
        return contract || {};
    },
    getContractById(id) {
        return find(contracts, function (item) { return item._id === id; });
    },
    receiveContracts(data) {
        contracts = data;
        this.status = 'success';
    },
    receiveContract(data) {
        contract = data;
        this.status = 'success';
    },
    receiveAddContractSuccess(data) {
        contract = data.contract;
        if (contract)
            contracts.push(contract);
        this.status = 'success';
        toast(i18next.t('NEW_CONTRACT_ADDED'), 'success');
    },
    receiveUpdateContractSuccess(data) {
        contract = data;
        if (contract) {
            const idx = this.getContractIndex(contract);
            if (idx < contracts.length) {
                contracts[idx] = contract;
            }
        }
        this.status = 'success';
        toast(i18next.t('CONTRACT_UPDATED'), 'success');
    },
    receiveUpdateContractFail(data) {
        this.status = 'fail';
        this.error = data.entity;
        toast(i18next.t('CONTRACT_UPDATE_FAILED'), 'error');
    },
    emitChange() {
        this.emit('change');
    },
    addChangeListener(callback) {
        this.on('change', callback);
    },
    removeChangeListener(callback) {
        this.removeListener('change', callback);
    },
});
ContractsStore.dispatchToken = AdminAppDispatcher.register(function (payload) {
    const action = payload.action;
    switch (action.type) {
        case ActionTypes.RECEIVE_CONTRACTS:
            ContractsStore.receiveContracts(action.data);
            ContractsStore.emitChange();
            break;
        case ActionTypes.RECEIVE_CONTRACT:
            ContractsStore.receiveContract(action.data);
            ContractsStore.emitChange();
            break;
        case ActionTypes.UPDATE_CONTRACT_SUCCESS:
            ContractsStore.receiveUpdateContractSuccess(action.data);
            ContractsStore.emitChange();
            break;
        case ActionTypes.UPDATE_CONTRACT_FAIL:
            ContractsStore.receiveUpdateContractFail(action.data);
            ContractsStore.emitChange();
            break;
        case ActionTypes.ADD_CONTRACT_SUCCESS:
            ContractsStore.receiveAddContractSuccess(action.data);
            ContractsStore.emitChange();
            break;
        default:
            break;
    }
});
export default ContractsStore;
